import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import diagramGris from '../../assets/diagram_gris.png';
import diagramBlanc from '../../assets/diagram_blanc.png';
import leadsGris from '../../assets/leads_gris.png';
import leadsBlanc from '../../assets/leads_blanc.png';
import modifyCardGris from '../../assets/modify_card_gris.png';
import modifyCardBlanc from '../../assets/modify_card_blanc.png';
import profileGris from '../../assets/profile_gris.png';
import profileBlanc from '../../assets/profile_blanc.png';
import meoriaLogo from '../../assets/meoria_manager_bleu.png';
import {
  PageContainer,
  Header,
  Logo,
  MenuContainer,
  MenuButton,
  ButtonText,
  MenuRow,
  ContentWrapper
} from './MenuStyles';

const Menu = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [managerEmail, setManagerEmail] = React.useState(null);

  React.useEffect(() => {
    // Fetch manager data from localStorage
    const managerDataString = localStorage.getItem('managerData');
    if (managerDataString) {
      const managerData = JSON.parse(managerDataString);
      setManagerEmail(managerData.email);
    }
  }, []);

  // Check active paths using the new /manager/ prefix
  const isAnalyticsActive = location.pathname === '/manager/analytics';
  const isLeadsActive = location.pathname === '/manager/leads';
  const isUpdateActive = location.pathname === '/manager/update';
  const isProfileActive = location.pathname === '/manager/profile';
  const isSpecialUser = managerEmail === 'dimitri@major-prepa.com';
  const canViewLeads = managerEmail === 'dimittri@meoria.com' || managerEmail === 'admin@isg.fr';

  return (
    <PageContainer>
      <MenuContainer>
        <Logo src={meoriaLogo} alt="Meoria Manager" style={{ marginTop: '1rem', marginBottom: '2rem' }} />
        
        <MenuRow 
          isActive={isAnalyticsActive}
          onClick={() => navigate('/manager/analytics')}
        >
          <MenuButton 
            isActive={isAnalyticsActive}
          >
            <img 
              src={isAnalyticsActive ? diagramBlanc : diagramGris} 
              alt="Statistics"
            />
            <ButtonText isActive={isAnalyticsActive}>Analyse</ButtonText>
          </MenuButton>
        </MenuRow>

        {canViewLeads && (
          <MenuRow
            isActive={isLeadsActive}
            onClick={() => navigate('/manager/leads')}
          >
            <MenuButton
              isActive={isLeadsActive}
            >
              <img
                src={isLeadsActive ? leadsBlanc : leadsGris}
                alt="Leads"
              />
              <ButtonText isActive={isLeadsActive}>Mes leads</ButtonText>
            </MenuButton>
          </MenuRow>
        )}

        {!isSpecialUser && (
          <MenuRow 
            isActive={isUpdateActive}
            onClick={() => navigate('/manager/update')}
          >
            <MenuButton 
              isActive={isUpdateActive}
            >
              <img 
                src={isUpdateActive ? modifyCardBlanc : modifyCardGris} 
                alt="Update"
              />
              <ButtonText isActive={isUpdateActive}>Mes fiches</ButtonText>
            </MenuButton>
          </MenuRow>
        )}

        <MenuRow 
          isActive={isProfileActive}
          onClick={() => navigate('/manager/profile')}
        >
          <MenuButton 
            isActive={isProfileActive}
          >
            <img 
              src={isProfileActive ? profileBlanc : profileGris} 
              alt="Profile"
            />
            <ButtonText isActive={isProfileActive}>Profil</ButtonText>
          </MenuButton>
        </MenuRow>
      </MenuContainer>

      <ContentWrapper>{children}</ContentWrapper>
    </PageContainer>
  );
};

export default Menu; 